import { render, staticRenderFns } from "./team-rating.vue?vue&type=template&id=c41aacb2&"
import script from "./team-rating.vue?vue&type=script&lang=js&"
export * from "./team-rating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports